import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService } from '@crosscutting/public_api';
import { environment } from '@env/environment';
import { RuitherstellersResponse } from '@models/claims';

@Injectable()
export class SchadeherstelService {
  constructor(private _http: HttpService) { }

  getSchadeherstellers(isAuto: boolean, kenteken: string, postcode14: string): Observable<RuitherstellersResponse> {
    let request = {
      selectieParameters: {
        objectsoort: isAuto ? 'OC0001' : 'OC0007', // auto : camper
        merkDispatch: 0,
        postcodeCijfers: postcode14,
        reparatiesoort: 'OS9102',
        schadeoorzaak: 'SO0111',
        kenteken: kenteken
      }
    };

    return this._http.post<RuitherstellersResponse>(environment.ophalenRuitherstellersUrl, request);
  }
}
